<template>
  <WizardContent
    :graphic="{
      type: 'gradient',
      assetsPath: 'image-maintenance',
    }"
  >
    <h4 class="mt-6 mb-9">
      Your account is currently undergoing maintenance
    </h4>
    <p class="p3 mb-6">
      Hi {{ firstName }}! Your account is currently undergoing maintenance, and you will be able
      to log in as soon as it is complete. If you have any questions please reach out to
      <a href="mailto:support@datapeople.io">support@datapeople.io</a>.
    </p>
    <p class="p3">
      Have a great day!
    </p>
  </WizardContent>
</template>

<script>
import WizardContent from '@/components/shared/WizardContent.vue';
import { mapState } from 'pinia';
import { useWizard } from '@/stores/wizard/wizard';

export default {
  name: 'TechnicalHold',
  components: {
    WizardContent,
  },
  emits: ['track-page-load'],
  computed: {
    ...mapState(useWizard, ['firstName']),
  },
  beforeCreate() {
    this.$emit('track-page-load', { page: 'Technical Hold' });
  },
};
</script>
